import { SelectModel } from "./core.model";

export interface GetUserRegisterSummaryRequest {
  numberOfItems?: number;
  duration: TimeDurationEnum
}

export interface GetUserRegisterSummaryResponse {
  titles: string[];
  userRegistered: number[];
}

export enum TimeDurationEnum{
  Daily = 1,
  Weekly = 2,
  Monthly = 3
}

export const TimeDurationList = [
    { value: 1, label: "Daily" },
    { value: 2, label: "Weekly" },
    { value: 3, label: "Monthly" },
];


export interface AdminWaitingJob
{
    type: AdminJobTypeEnum;
    count: number;
}

export enum AdminJobTypeEnum
{
    ReportedActivity = 1,
    MarathonStartedDistances = 2,
    DraftRunEvents = 3,
    NotApprovedScrapedEvents = 4,
}
export interface AdminJobTypeInfo extends SelectModel{
  url: string
}
export const AdminJobTypeInfoMap: Record<AdminJobTypeEnum, AdminJobTypeInfo> = {
  [AdminJobTypeEnum.ReportedActivity]: {
    value: AdminJobTypeEnum.ReportedActivity, 
    label: "None Processed Reported Activities", 
    url: "activities/reports" 
  },
  [AdminJobTypeEnum.MarathonStartedDistances]: {
    value: AdminJobTypeEnum.MarathonStartedDistances, 
    label: "Marathon Started Distances", 
    url: "run-events?only-started-distances=true&type=Marathon" 
  },
  [AdminJobTypeEnum.DraftRunEvents]: {
    value: AdminJobTypeEnum.DraftRunEvents, 
    label: "Draft Run Events", 
    url: "run-events" 
  },
  [AdminJobTypeEnum.NotApprovedScrapedEvents]: {
    value: AdminJobTypeEnum.NotApprovedScrapedEvents, 
    label: "Not Approved Scraped Events", 
    url: "scraped-events" 
  },
};
